import { useUserStore } from "../stores/usuario_store";

export const getPermissoesComponent = async (perfilAccessUser, componente = "artigos") => {
  const userStore = useUserStore();
  try {
    const _response = await useAPI.get(`/users/getUserPermission/${componente}/?t=${perfilAccessUser}`);
    return _response.data;
  } catch (error) {
    console.log(error);
  }
};
